<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <span class="text-muted text-uppercase">Test Package Sample</span>
        <b-button v-if="parent_index" class="float-right" @click="deletePackageSample" variant="danger" size="sm">
          <i class="fal fa-trash" />
        </b-button>
      </b-card-header>
      <div class="py-3 px-5">
        <b-form-group label="Sample Name" :label-cols="2" :horizontal="true">
          <b-form-input type="text" v-model="sample_name" debounce="300" placeholder="Depth 1, Sample 1, ..." />
        </b-form-group>
        <template v-if="sample_type_analytes">
          <b-form-group label="Analytes" :label-cols="2" class="mb-0">
            <div class="row">
              <div class="col-md-4" v-for="(option, index) in sample_type_analytes.models" :key="index">
                <b-form-checkbox v-model="checked" :value="option.id" inline>
                  <strong>{{ option.abbrev }}</strong>: {{ option.name }}
                </b-form-checkbox>
              </div>
            </div>
          </b-form-group>
        </template>
      </div>
    </b-card>
  </div>
</template>

<script>
import AnalyteCollection from "@/collections/lab/AnalyteCollection";

export default {
  name: "TestPackageFormSampleCard",
  props: {
    package_sample: {
      type: Object,
      default: () => {
        return {};
      }
    },
    parent_index: {
      type: Number,
      default: 0
    },
    sample_type_analytes: {
      type: Object,
      default: () => new AnalyteCollection()
    }
  },
  computed: {
    sample_name: {
      get() {
        return this.package_sample.name;
      },
      set(value) {
        this.$emit("updatePackageSample", {
          index: this.parent_index,
          field: "name",
          value
        });
      }
    },
    checked: {
      get() {
        return this.package_sample.analytes.map((val) => { return val.id });
      },
      set(value) {
        const formatted = this.formatPackageAnalytes(value).map((val) => {
          return {
            id: val
          };
        });

        this.$emit("updatePackageSample", {
          index: this.parent_index,
          field: "analytes",
          value: formatted
        });
      }
    }
  },
  methods: {
    deletePackageSample() {
      this.$emit("deletePackageSample", this.parent_index);
    },
    handleTagged(payload) {
      this.$emit('tagged', payload);
    },
    formatPackageAnalytes(value) {
      switch (typeof value) {
        case 'string':
          return [value];
        case 'object':
          return Object.values(value);
        default:
          return value;
      }
    }
  },
  components: {
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
